import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 24, height = 24, color = 'currentColor', customClass = '' }: IconComponentProps) => <svg width={width} height={height} viewBox='0 0 24 24' class={customClass}>
  <path d='M10 6L8.59003 7.41L13.17 12L8.59003 16.59L10 18L16 12L10 6Z' fill={color} />
</svg>
